import React, { memo } from 'react'
import { formatToDecimals } from 'src/libs/qb-brand-web-components'

import Popup from '../shared/popup/Popup'
import CustomTextField from '../shared/inputs/CustomTextField'

import { SELL_NFTS_PROFILE_DISPATCH } from '../../store/reducers/nft/sellNft'
import { numberCeil } from '../../util/number.helpers'
import customConfig from 'customConfig'
import { Stack } from '@mui/material'
import Text from '../text/Text'

const SellNft = ({
  t,
  tokenProfile,
  onFormSubmit,
  dispatchAction,
  sellNftProfile: { numberOfPoints, error },
  onCancel,
  salesFeePercentage,
  id,
  nftId
}) => {
  const { name, symbol, onramp } = tokenProfile
  return (
    <Popup
      title={t(customConfig.sellYourNftLabel)}
      description={t(customConfig.sellNftDescLabel, { name })}
      submitLabel={t(customConfig.sellNftLabel)}
      onFormSubmit={() => onFormSubmit(nftId, id, onramp * numberOfPoints)}
      cancelLabel={t('common.cancel')}
      onCancel={onCancel}
    >
      <Stack spacing={2} mt={2}>
        <CustomTextField
          label={t('nft.enter-number-of-points')}
          error={t(error[SELL_NFTS_PROFILE_DISPATCH.NUMBER_OF_POINTS])}
          value={numberOfPoints}
          positiveNumber
          onChange={(value) =>
            dispatchAction(SELL_NFTS_PROFILE_DISPATCH.NUMBER_OF_POINTS, value)
          }
        />
        <Stack
          spacing={1}
          sx={{
            color: 'var(--layout-nav-text-primary-color)',
            bgcolor: 'background.neutral',
            borderRadius: 2,
            px: 2,
            py: 1
          }}
        >
          <Stack direction='row' spacing={2}>
            <Text variant='subtitle2' label={`${t('nft.sales-fee')}:`} />
            <Text
              variant='subtitle2'
              label={`${formatToDecimals(Number(salesFeePercentage), 2)}%`}
              fontWeight={700}
            />
          </Stack>
          <Stack direction='row' spacing={2}>
            <Text
              label={`${t('nft.total-you-receive', { symbol })}:`}
              variant='subtitle2'
            />
            <Text
              label={numberCeil(
                numberOfPoints - (numberOfPoints * salesFeePercentage) / 100
              )}
              variant='subtitle2'
              fontWeight={700}
            />
          </Stack>
        </Stack>
      </Stack>
    </Popup>
  )
}

export default memo(SellNft)
